module.exports = __webpack_public_path__ + "static/img/20210508.2828bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20210508.png
// module id = 0ySb
// module chunks = 3